import { useState } from 'react';
import { subscribe } from '@/api';

type Props = {
  open?: boolean;
  variant?: 'banner' | 'modal' | 'panel';
  onClose?: () => void;
};

export default function HostingPaywall({ open = true, variant = 'banner', onClose }: Props) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!open) return null;

  const start = async () => {
    setErr(null);
    setBusy(true);
    try {
      const res = await subscribe('hosting');
      if (res.url) {
        window.location.assign(res.url);
        return;
      }
      onClose?.();
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'could not start hosting');
    } finally {
      setBusy(false);
    }
  };

  const inner = (
    <div data-testid="hosting-paywall" className={variant === 'banner' ? 'text-xs bg-accent/10 border border-accent/30 rounded-md px-3 py-2.5 text-textp' : 'text-sm text-textp'}>
      <div className="font-medium">Put a card on file to host</div>
      <p className="text-texts mt-1 leading-relaxed">
        New accounts get 20 credits to finish the site. Hosting is a monthly plan billed to your card. Usage meters on the same invoice. Terraform apply runs after payment.
      </p>
      {err && <div className="mt-2 text-error">{err}</div>}
      <button
        type="button"
        data-testid="hosting-paywall-start"
        disabled={busy}
        onClick={() => void start()}
        className="mt-2 inline-flex items-center gap-1 text-accent hover:text-accent-hover font-medium disabled:opacity-60"
      >
        {busy ? 'Starting…' : 'Start hosting'}
        <i className="ri-arrow-right-line" />
      </button>
    </div>
  );

  if (variant === 'modal') {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
        <div className="w-[420px] max-w-[92vw] bg-surface border border-border rounded-xl p-5" onClick={(e) => e.stopPropagation()}>
          {inner}
        </div>
      </div>
    );
  }
  return inner;
}
